export default __webpack_public_path__ + "static/media/hoodie-2.e017bf34.png";